export const formatTitle = (title: string) => `${title} | Humand`;
